import { View, StyleSheet } from "react-native";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import Logo from "../logos/Logo";

function UpgradeModal({ visible, companionName, proLogo, message, onUpgrade, onClose, buttonText }) {
  const { isMedium } = useResponsiveScreen();

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      style={{ width: isMedium ? "40%" : "80%" }}>
      <View style={styles.container}>
        <Logo uri={proLogo} height={90} width={250} />
        <CustomSpacing type="vertical" size="s" />

        <CustomText
          text="companion_wants_to_talk"
          size="xxl"
          weight="bold"
          style={styles.centeredText}
          interpolation={{ companionName }} // Pass companionName here
        />
        <CustomSpacing type="vertical" size="m" />

        <CustomText useTranslationText={false} text={message} size="l" style={styles.centeredText} />
        <CustomSpacing type="vertical" size="l" />

        <CustomButton text={buttonText} size="l" styleType="primary" onPress={onUpgrade} aria-label="Upgrade button" />
      </View>
    </CustomModal>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  centeredText: {
    textAlign: "center",
  },
});

export default UpgradeModal;
